import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cxShowableField',
})
export class CxShowableFieldPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter((x: any) => !x.deleted);
  }
}
